@let rule = editingRuleSg();

<div class="atn-conditions-tab">
  <!-- --------------------------- General Section --------------------------- -->
  <atn-ds-section name="General">
    <div class="atn-conditions-tab__general-section">
      <atn-ds-text
        label="Rule Name"
        [value]="rule?.name"
        (change)="ruleNameChangeHandler($event ?? '')"
        data-test-id="ruleNameLabel"
      />
      <!-- The value needs to be set differently because the entity collection
    won't upsert the change unless the change event is fired. -->
      <atn-ds-number
        label="Priority"
        [value]="rule?.priority"
        (change)="$event && rulePriorityChangeHandler($event)"
        data-test-id="priorityLabel"
      />
      <atn-ds-checkbox
        label="Is Active?"
        [selected]="rule?.isActive ?? false"
        (selectedChange)="ruleIsActiveChangeHandler($event)"
      />
    </div>
  </atn-ds-section>
  <!-- -------------------------- Criteria Section --------------------------- -->
  <atn-ds-section
    name="Criteria"
    [style.height]="'100%'"
  >
    <atn-rate-gl-filter
      [filter]="rule.filter"
      (filterChange)="filterChangeHandler($event)"
    ></atn-rate-gl-filter>
  </atn-ds-section>
</div>
